import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecomendadorComponent } from '../../../comun/components/recomendador/recomendador.component';
import { TarificacionSaludComponent } from '../tarificacion-salud/tarificacion-salud.component';
import { DatosRecomendadorPropuesta, PolizaSalud, TipoCliente } from '../../../comun/model/salud.model';
import { CatalogoSaludApiService } from '../../../comun/services/api/catalogo-salud-api.service';
import { FlujoPolizaNavigationComponent } from '../../../comun/components/base/flujo-poliza-navigation.component';
import { Router } from '@angular/router';
import { CatalogoSvgStoreService } from '../../../comun/services/store/catalogo-svg-store.service';
import { AgrupacionPolizasSalud, ColectivasAgrupacion, ModoRecomendador, PolizaSaludColectiva, RecomendadorColectiva } from '../../../comun/model/recomendador.model';
import { PolizaSaludApiService } from '../../services/api/poliza-salud-api.service';
import { CaCardComponent } from "@global-front-components/ui/card";
import { InformacionTarificacionComponent } from '../informacion-tarificacion/informacion-tarificacion.component';
import { RecomendadorApiService } from '../../../comun/services/api/recomendador-api.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CaButtonComponent } from '@global-front-components/ui/button';
import { PolizaSaludStoreService } from '../../services/store/poliza-salud-store.service';

@Component({
	selector: 'app-tarificacion-recomendador',
	standalone: true,
	imports: [
		CommonModule,
		RecomendadorComponent,
		TarificacionSaludComponent,
		TranslateModule,
		CaCardComponent,
		InformacionTarificacionComponent,
		CaButtonComponent
	],
	templateUrl: './tarificacion-recomendador.component.html',
	styleUrls: ['./tarificacion-recomendador.component.scss']
})
export class TarificacionRecomendadorComponent extends FlujoPolizaNavigationComponent<PolizaSaludStoreService> implements OnInit {
	esDental = false;
	colectivaSenior: number | null = null;
	tiposCliente: TipoCliente[] = [];
	tipoClienteSeleccionado: TipoCliente;
	propuesta: PolizaSalud;
	tipoDocumento: string = null;
	colectivasAgrupacion: ColectivasAgrupacion | null = null;
	agrupacionesPropuestas: AgrupacionPolizasSalud[] = [];
	idOpcionPrimerNivel: number | null = null;
	idOpcionInicial: number | null = null;
	todosProductos: AgrupacionPolizasSalud[] = [];
	mostrandoTodos = false;
	descTipoClienteSeleccionado: string;
	mostrarComparativoCoberturas = false;
	modoRecomendador: ModoRecomendador;
	mostrarInfoSeniorYNormal = false;
	datosRecomendadorPropuesta: DatosRecomendadorPropuesta | null = null;

	private readonly codCanalCajas = 'CJ';

	constructor(
		router: Router,
		polizaStore: PolizaSaludStoreService,
		catalogoStore: CatalogoSvgStoreService,
		private catalogoSaludService: CatalogoSaludApiService,
		private polizaSaludApiService: PolizaSaludApiService,
		private recomendadorApiService: RecomendadorApiService,
		private translateService: TranslateService
	) {
		super(router, polizaStore, catalogoStore);
		this.tipoDocumento = this.getNavigationParam('tipoDocumento');
		this.esDental = this.getNavigationParam('esDental');
		this.colectivaSenior = this.getNavigationParam('colectivaSenior');
		this.modoRecomendador = this.getNavigationParam('modoRecomendador');
	}

	ngOnInit(): void {
		this.catalogoSaludService.getTiposCliente().subscribe(tc => this.tiposCliente = tc);
		this.polizaStore.polizaSubject$.subscribe(p => this.propuesta = p as PolizaSalud);
	}

	onColectivasChange(colectivas: ColectivasAgrupacion) {
		this.colectivasAgrupacion = colectivas;
		this.agrupacionesPropuestas = [];
		this.multitarificar(colectivas);
	}

	multitarificar(colectivas: ColectivasAgrupacion) {
		if (this.propuesta && colectivas) {
			const visibles = this.seleccionarColectivasMostrar(colectivas);

			const codigosColectivas = [
				...(visibles.map(c => c.numColectiva) ?? [])
			];

			this.polizaSaludApiService
				.multiTarificarPoliza(this.propuesta, codigosColectivas)
				.subscribe(multiTarificacion => {
					if (multiTarificacion?.propuestas?.length) {
						this.agrupacionesPropuestas = this.agruparPolizasPorColectiva(multiTarificacion.propuestas, visibles);
					}
					this.mostrarComparativoCoberturas = multiTarificacion?.mostrarComparativoCoberturas || false;
				});
		}
	}

	//Solo aplica si no viene senior
	private seleccionarColectivasMostrar(colectivas: ColectivasAgrupacion): RecomendadorColectiva[] {
		const primarias = colectivas?.colectivas ?? [];
		const alternativas = colectivas?.colectivasAlternativas ?? [];

		if (primarias.length > 0) return primarias;

		if (alternativas.length === 0) return [];

		// mostrar alternativas solo si todas tienen el mismo codErrorAsociado
		const cod0 = alternativas[0].codErrorAsociado;
		const todasMismoError = alternativas.every(a => a.codErrorAsociado === cod0);

		return todasMismoError ? alternativas : [];
	}

	private agruparPolizasPorColectiva(polizas: PolizaSalud[] = [], colectivasMostrar: RecomendadorColectiva[] = []): AgrupacionPolizasSalud[] {
		const resultado: AgrupacionPolizasSalud[] = [];

		for (const poliza of polizas) {
			const colectiva = colectivasMostrar.find(r => r.numColectiva === poliza.codColectiva);
			// si es descuento, la saltamos
			if (colectiva?.esDescuento) continue;
			const nombre = (colectiva?.txtColectiva ?? poliza.descripcionModalidadColectiva ?? poliza.nombreProducto ?? '').trim();

			const polizaColectiva: PolizaSaludColectiva = { polizaSalud: poliza, colectiva: colectiva };
			// buscamos si hay una colectiva de descuento para esta póliza
			const colectivaDescuento = colectivasMostrar.find(r => r.numColectivaPrincipal === poliza.codColectiva && r.esDescuento);
			if (colectivaDescuento) {
				const polizaDescuento = polizas.find(p => p.codColectiva === colectivaDescuento.numColectiva);
				if (polizaDescuento) {
					polizaColectiva.polizaDescuento = polizaDescuento;
					polizaColectiva.colectivaDescuento = colectivaDescuento;
				}
			}
			const grupo = resultado.find(g => g.nombreColectivaPadre === nombre);
			if (grupo) {
				grupo.polizasColectivas.push(polizaColectiva);
			} else {
				resultado.push({ nombreColectivaPadre: nombre, polizasColectivas: [polizaColectiva] });
			}
		}
		return resultado;
	}

	onVerTodosProductos() {
		if (!this.idOpcionPrimerNivel && !this.idOpcionInicial) return;
		const idOpcionBuscar = this.colectivasAgrupacion.codCanal === this.codCanalCajas ? this.idOpcionInicial : this.idOpcionPrimerNivel;
		this.mostrandoTodos = true;
		this.recomendadorApiService.getColectivasAgrupacionesRecomendador(
			idOpcionBuscar,
			this.translateService.currentLang?.toUpperCase() || 'ES',
			this.esDental
		).subscribe(colectivas => {
			if (colectivas?.colectivas?.length || colectivas?.colectivasAlternativas?.length){
				this.multitarificarTodos(colectivas);
			}
		});
	}

	onVerAlternativaSenior() {
		this.mostrandoTodos = true;
		this.recomendadorApiService.getColectivasAgrupacionesRecomendador(
			this.idOpcionPrimerNivel,
			this.translateService.currentLang?.toUpperCase() || 'ES',
			this.esDental
		).subscribe(colectivas => {
			if (colectivas?.colectivas?.length || colectivas?.colectivasAlternativas?.length){
				this.multitarificarTodos(colectivas);
			}
		});
	}

	multitarificarTodos(colectivas: ColectivasAgrupacion) {
		const visibles = this.seleccionarColectivasMostrar(colectivas);
		const codigos = visibles.map(c => c.numColectiva);

		this.polizaSaludApiService
				.multiTarificarPoliza(this.propuesta, codigos)
				.subscribe(multiTarificacion => {
					if (multiTarificacion?.propuestas?.length) {
						this.todosProductos = this.agruparPolizasPorColectiva(multiTarificacion.propuestas, visibles);
					}
					this.mostrarComparativoCoberturas = multiTarificacion?.mostrarComparativoCoberturas || false;
		});
	}

	onTipoClienteChange(tipoCliente: TipoCliente) {
		this.tipoClienteSeleccionado = tipoCliente;
	}

	onIdOpcionPrimerNivelChange(idOpcion: number) {
		this.idOpcionPrimerNivel = idOpcion;
	}

	onIdOpcionInicialChange(idOpcion: number) {
		this.idOpcionInicial  = idOpcion;
	}

	onMostrarInfoSeniorYNormalChange(mostrar: boolean) {
		this.mostrarInfoSeniorYNormal = mostrar;
	}

	onDatosRecomendadorPropuestaChange(datos: DatosRecomendadorPropuesta) {
		this.datosRecomendadorPropuesta = datos;
	}

	guardarProyecto() {
		this.polizaStore.setPoliza(this.propuesta);
		this.polizaStore.setAgrupacionPolizasSalud(this.todosProductos?.length > 0 ? this.todosProductos : this.agrupacionesPropuestas);
		this.polizaStore.setDatosRecomendador(this.datosRecomendadorPropuesta);
		this.navigate('salud/guardar-multi-proyecto', true, {esDental: this.esDental});
	}

	volverAlRecomendador() {
		this.mostrandoTodos = false;
		this.todosProductos = [];
	}

	volverADatos() {
		this.volver();
	}
}
